import { Button, TextField } from "@mui/material";
import clsx from "clsx";
import { Formik } from "formik";
import React from "react";
import { t } from "ttag";
import * as Yup from "yup";
import SimpleModal from "../../widgets/SimpleModal/SimpleModal";
import useStyles from "../DebugDevices/AddEditDebugDevice.style";

const MessageSchema = Yup.object().shape({
  header: Yup.string().required(t`Required`),
  body: Yup.string().required(t`Required`)
});

interface IProps {
  recipientCount: number;
  sending: boolean;
  onClose: () => void;
  onSend: (values: { header: string; body: string }) => void;
}

const SendPushNotificationDialog = ({ recipientCount, sending, onClose, onSend }: IProps) => {
  const styles: any = useStyles();

  const CustomizedTextField = ({
    label,
    handleChange,
    errors,
    name,
    helperText,
    values
  }: any) => (
    <TextField
      label={label}
      name={name}
      helperText={errors[name] || helperText}
      className={styles.fieldStyle}
      variant={'standard'}
      onChange={handleChange}
      value={values[name] || ""}
      error={!!errors[name]}
      disabled={sending}
    />
  );

  return (
    <SimpleModal
      showModal={true}
      title={t`Send test push to ${recipientCount} device(s)`}
      hideBtns
      closeModal={onClose}
    >
      <Formik
        initialValues={{ header: "", body: "" }}
        validateOnChange={false}
        onSubmit={onSend}
        validationSchema={MessageSchema}
      >
        {(props: any) => {
          const { values, errors, handleChange, handleSubmit } = props;
          return (
            <form className={styles.fieldsContainer} onSubmit={handleSubmit}>
              <CustomizedTextField
                label={t`Header`}
                name="header"
                helperText={t`Notification title`}
                handleChange={handleChange}
                values={values}
                errors={errors}
              />
              <CustomizedTextField
                label={t`Body`}
                name="body"
                helperText={t`Notification text`}
                handleChange={handleChange}
                values={values}
                errors={errors}
              />

              <div className={styles.actionsContainer}>
                <Button onClick={onClose} disabled={sending} className={styles.sharedButtonStyle}>
                  {t`Cancel`}
                </Button>
                <Button
                  type="submit"
                  disabled={sending}
                  className={clsx(styles.sharedButtonStyle, styles.submitButton)}
                >
                  {sending ? t`Sending...` : t`Send`}
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </SimpleModal>
  );
};

export default SendPushNotificationDialog;
